import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3827ac30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { for: "" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "position-relative d-flex align-items-center input-group" }
const _hoisted_4 = {
  key: 0,
  class: "input-group-text input-group-solid prefix"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "input-loader"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "mt-1 mb-0"
}
const _hoisted_10 = {
  key: 1,
  class: "mb-0 mt-1"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 2,
  class: "col range-advice mt-2 border px-4 py-3 rounded-2 shadow-sm list-style-none"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rango mínimo:", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Rango máximo:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_text_formatter = _resolveDirective("text-formatter")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.attributes.class)
        }, [
          _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.value), 1)
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.prefix)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.prefix), 1))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("input", _mergeProps(_ctx.attributes, {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.numericValue) = $event)),
              disabled: _ctx.attributes.disabled || _ctx.loading,
              class: {
            'ps-0': _ctx.prefix,
          }
            }), null, 16, _hoisted_5), [
              [_vModelDynamic, _ctx.numericValue],
              [_directive_text_formatter, _ctx.settings.directives.formatter]
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true)
          ]),
          (_ctx.validationState.$errors.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationState.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: error.$uid,
                    class: "text-danger fw-bold mb-0"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.serverErrors.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverErrors, (error, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${_ctx.attributes.name}-error-${index}`,
                    class: "text-danger fw-bold mb-0"
                  }, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.$sanitize(error)
                    }, null, 8, _hoisted_11)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.min || _ctx.max)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                (_ctx.min)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("span", null, _toDisplayString(_ctx.prefix) + " " + _toDisplayString(_ctx.min), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.max)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("span", null, _toDisplayString(_ctx.prefix) + " " + _toDisplayString(_ctx.max), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}